import { Table, Typography } from "antd";
import { useSelector } from "react-redux";

const { Title } = Typography;

const format = (v) =>
  `₹${Number(v || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
  })}`;

const Section5 = ({ printMode = false }) => {
  const { section5 } = useSelector((state) => state.gstr3b);

  // ✅ Convert to map (fast lookup)
  const backendMap = Object.fromEntries(
    (section5 || []).map((item) => [item.key, item])
  );

  const get = (key) => backendMap[key] || {};

  const data = [
    // 🔥 HEADER ROW (1,2,3)
    {
      key: "header",
      label: "1",
      inter: "2",
      intra: "3",
      isHeaderRow: true,
    },

    // ✅ NIL / EXEMPT
    {
      key: "nil_exempt",
      label: "Composition Scheme, Exempted, Nil Rated",
      inter: get("nil_exempt").inter ?? 0,
      intra: get("nil_exempt").intra ?? 0,
    },

    // ✅ NON GST
    {
      key: "non_gst",
      label: "Non-GST supply",
      inter: get("non_gst").inter ?? 0,
      intra: get("non_gst").intra ?? 0,
    },
  ];

  const columns = [
    {
      title: "Nature of Supply",
      dataIndex: "label",
      width: "60%",
      render: (value, record) => {
        if (record.isHeaderRow) {
          return {
            children: value,
            props: {
              style: {
                textAlign: "center",
                background: "#fafafa",
              },
            },
          };
        }
        return value;
      },
    },

    {
      title: "Inter-State Supplies",
      dataIndex: "inter",
      align: "right",
      width: "20%",
      render: (value, record) => {
        if (record.isHeaderRow) {
          return {
            children: value,
            props: {
              style: {
                textAlign: "center",
                background: "#fafafa",
              },
            },
          };
        }
        return format(value);
      },
    },

    {
      title: "Intra-State Supplies",
      dataIndex: "intra",
      align: "right",
      width: "20%",
      render: (value, record) => {
        if (record.isHeaderRow) {
          return {
            children: value,
            props: {
              style: {
                textAlign: "center",
                background: "#fafafa",
              },
            },
          };
        }
        return format(value);
      },
    },
  ];

  return (
    <>
      <Title level={5}>
        5. Values of exempt, nil-rated and non-GST inward supplies
      </Title>

      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        bordered
        rowKey="key"
        scroll={printMode ? undefined : { x: "max-content" }}
      />
    </>
  );
};

export default Section5;